import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

export default function CommunicationSafetyNotice() {
  return (
    <section className="rounded-[28px] border border-amber-200 bg-amber-50 p-4 shadow-sm dark:border-amber-500/20 dark:bg-amber-500/10">
      <p className="flex items-start gap-3 text-sm leading-6 text-amber-800 dark:text-amber-200">
        <FaExclamationTriangle className="mt-1 shrink-0" />
        <span>
          Les suppressions sont définitives. Utilisez cette section surtout pour
          nettoyer les anciennes saisons ou les données devenues inutiles. Avant
          de valider, vérifiez bien la période sélectionnée.
        </span>
      </p>
    </section>
  );
}